module.exports = __webpack_public_path__ + "static/Calibre-Regular-b63c62e591d0c8fbe2c8f009883346d5.woff2";